module.exports = __webpack_public_path__ + "img/navigationBgc.ba78422d.png";